import { useRef, useState } from "react";
import { Paperclip, X, UploadSimple } from "@phosphor-icons/react";
import api from "@/lib/api";

export const FileUpload = ({ attachments = [], onChange }) => {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const handleFiles = async (files) => {
    setUploading(true);
    const uploaded = [];
    for (const file of Array.from(files)) {
      const formData = new FormData();
      formData.append("file", file);
      try {
        const { data } = await api.post("/upload", formData, { headers: { "Content-Type": "multipart/form-data" } });
        uploaded.push(data);
      } catch {}
    }
    onChange([...attachments, ...uploaded]);
    setUploading(false);
  };

  const removeAt = (idx) => onChange(attachments.filter((_, i) => i !== idx));

  return (
    <div>
      <div
        data-testid="file-upload-dropzone"
        onDragOver={(e) => e.preventDefault()}
        onDrop={(e) => { e.preventDefault(); handleFiles(e.dataTransfer.files); }}
        onClick={() => inputRef.current?.click()}
        className="border border-dashed border-border p-3 text-center cursor-pointer hover:bg-muted transition-colors text-xs text-muted-foreground flex items-center justify-center gap-2"
        style={{ borderRadius: "2px" }}
      >
        <UploadSimple size={15} />
        {uploading ? "Uploading..." : "Drag & drop or click to attach files"}
      </div>
      <input ref={inputRef} type="file" multiple hidden data-testid="file-upload-input" onChange={(e) => handleFiles(e.target.files)} />
      {attachments.length > 0 && (
        <div className="flex flex-wrap gap-2 mt-2">
          {attachments.map((a, idx) => (
            <a key={idx} href={`${process.env.REACT_APP_BACKEND_URL}${a.url}`} target="_blank" rel="noreferrer"
              data-testid={`attachment-chip-${idx}`}
              className="flex items-center gap-1 text-xs px-2 py-1 bg-muted border border-border" style={{ borderRadius: "2px" }}>
              <Paperclip size={12} /> {a.name}
              <button type="button" onClick={(e) => { e.preventDefault(); removeAt(idx); }} data-testid={`attachment-remove-${idx}`}><X size={12} /></button>
            </a>
          ))}
        </div>
      )}
    </div>
  );
};
